import React from 'react';
import './greenline.style.scss';

const GreenLine = ({classx}) => (
  <div className={`greenLine ${classx}`} />
)

export default GreenLine;

